import { useTranslation } from 'react-i18next'

import { useCampaignRebateSort } from '@pages/Traders-Room/Campaign-Results/Rebate/hooks/useCampaignRebateSort'

import { SortHeaderAlignType } from '@ui/v2/Table/Table'

import {
  isCampaignCalculationAccountType,
  isCampaignCalculationTiersType,
} from '@model/CampaignCalculationType'
import { isCampaignClientRebateType } from '@model/CampaignType'
import { ClientRebateCampaignDetailDto } from '@model/ClientRebateCampaignDetailDto'

export const useCampaignRebateSortSettings = (
  detail?: ClientRebateCampaignDetailDto,
  sort?: ReturnType<typeof useCampaignRebateSort>
) => {
  const { t } = useTranslation()

  const getCampaignRebateValue = () => {
    const calcId = detail?.calculationType?.id
    if (isCampaignCalculationTiersType(calcId)) return t('Campaigns.Tier Reached')
    if (isCampaignCalculationAccountType(calcId)) return t('Account Type')
    return detail?.calculationType?.name || ''
  }

  const hasRebateValueColumn =
    isCampaignClientRebateType(detail?.type?.id) &&
    !isCampaignCalculationAccountType(detail?.calculationType?.id)

  const sortOptions: { id: string; name: string; align: SortHeaderAlignType }[] = [
    { id: 'CampaignRebatePeriod.From', name: t('Campaigns.Round Date'), align: 'left' },
    { id: 'Volume', name: t('Campaigns.Total Volume Traded'), align: 'center' },
    ...(hasRebateValueColumn
      ? [{ id: 'RebateValue', name: getCampaignRebateValue(), align: 'center' as const }]
      : []),
    { id: 'AccumulatedRebate', name: t('Campaigns.Accumulated Rebate'), align: 'center' },
  ]

  const getSortName = () => sortOptions.find((x) => x.id === sort?.sort)?.name

  return { getCampaignRebateValue, getSortName, sortOptions }
}
